module.exports = __webpack_public_path__ + "img/check_02.6aa2a91d.png";